import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['a', 'b'];

  switch() {
    this.aTarget.classList.toggle('hidden');
    this.bTarget.classList.toggle('hidden');
  }

  switchBy(event) {
    const { target } = event.detail;
    this.#switchByTarget(target);
  }
  #switchByTarget(id) {
    if (id === 'a') {
      this.aTarget.classList.remove('hidden');
      this.bTarget.classList.add('hidden');
    } else {
      this.bTarget.classList.remove('hidden');
      this.aTarget.classList.add('hidden');
    }
  }
}
